import { Component } from '@angular/core';

@Component({
    selector: 'app-impressum',
    template: require('./impressum.component.html'),
    styles: [
        require('./impressum.component.css')
    ]
})

export class ImpressumComponent {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/impressum/impressum.component.ts